import { UseMutationResult } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import { createContext } from "react";

import { AddClientRequest } from "@/types/request/AddClientRequest";
import { AddClientErrorResponse, AddClientResponse } from "@/types/response/AddClientResponse";

export type AddClientContextType = {
    addClientError?: AddClientErrorResponse;
    addClient: UseMutationResult<AxiosResponse<AddClientResponse>, AxiosError<AddClientErrorResponse>, AddClientRequest>;
    isPending: boolean;
    reset: () => void;
}

export const AddClientContext = createContext<AddClientContextType | undefined>(undefined);
